import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios';


const initialState = {
    defaultOrder : "",
    isLoading : false,
    error : ''
}

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
const API_URL = `${BACKEND_URL}/api/setting/defaultorder/`;

//Get single warehouse
export const getDefaultOrder = createAsyncThunk(
  "defaultOrder/findOrCreate",
  async(thunkAPI) => {
    try {
        const response = await axios.get(API_URL)
        return response.data
    } catch (error) {
      const message = (
        error.response && error.response.data 
        && error.response.data.message) 
        || error.message || error.toString();
        console.log(message)
        return thunkAPI.rejectWithValue(message)
    }
  }
)

export const updateDefaultOrder = createAsyncThunk(
  "defaultOrder/update",
  async(formData, thunkAPI) => {
    try {
        const response = await axios.patch(API_URL, formData)
        return response.data
    } catch (error) {
      const message = (
        error.response && error.response.data 
        && error.response.data.message) 
        || error.message || error.toString();
        console.log(message)
        return thunkAPI.rejectWithValue(message)
    }
  }
)

const defaultOrderSlice = createSlice({
  name: "defaultOrder",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getDefaultOrder.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getDefaultOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.defaultOrder = (action.payload);
      })
      .addCase(getDefaultOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
  }
});

export const selectIsLoading = (state) => state.defaultOrder.isLoading
export const selectDefaultOrder = (state) => state.defaultOrder.defaultOrder

export default defaultOrderSlice.reducer